import { Input } from "@web-app/components";
import { AppFilterType, WorkspaceConnection } from "@web-app/types";

import TabPanelTitle from "./TabPanelTitle";
import { TabPanelWrapper } from "./TabPanelWrapper";

export default function ConnectionsFilterTab({
  connections,
  onChangeConnection,
  temporaryAppFilter,
}: {
  connections: WorkspaceConnection[];
  onChangeConnection: (value: string, connectionId: string) => void;
  temporaryAppFilter: AppFilterType;
}) {
  return (
    <TabPanelWrapper>
      <TabPanelTitle>Connections</TabPanelTitle>
      <div className="mb-3 lg:mb-5 mt-1 md:mt-2 flex flex-col gap-1 overflow-y-auto ">
        {[...connections]
          .sort((a, b) =>
            a.connectedWorkspace.name.localeCompare(b.connectedWorkspace.name),
          )
          .map((connection) => (
            <Input
              key={connection.connectedWorkspace.id}
              type="checkbox"
              rightLabel={connection.connectedWorkspace.name}
              value={
                temporaryAppFilter.workspaceIds.includes(
                  connection.connectedWorkspace.id,
                )
                  ? "true"
                  : "false"
              }
              onChange={(value) =>
                onChangeConnection(value, connection.connectedWorkspace.id)
              }
            />
          ))}
      </div>
    </TabPanelWrapper>
  );
}
